import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SearchBoxConfig } from '@spartacus/storefront';
import { BehaviorSubject, Observable } from 'rxjs';
import { BaseService } from '../../shared/services/base.service';
import { OspSearchResultModel } from '../model/osp-search-result.model';

@Injectable({
  providedIn: 'root',
})
export class OspCategoriesService {
  public searchResult = new BehaviorSubject({});
  searchResult$: Observable<OspSearchResultModel>;

  public contentItemsSearchResult = new BehaviorSubject<OspSearchResultModel>(null);
  contentItemsSearchResult$ = this.contentItemsSearchResult.asObservable();

  constructor(
    public readonly baseService: BaseService,
    private http: HttpClient
  ) {}

  getContentItems(
    contentCategoryCode: string,
    contentItemCode: string
  ): Observable<any> {
    let queryParams =
      contentItemCode !== undefined ? { item: contentItemCode } : {};
    return this.baseService.get(
      'help-center/' + contentCategoryCode,
      queryParams
    );
  }

  search(query: string, config: SearchBoxConfig): Observable<any> {
    if (!query || query === '') {
      this.clearResults();
      return;
    }

    if (
      config.minCharactersBeforeRequest &&
      query.length < config.minCharactersBeforeRequest
    ) {
      return;
    }

    const queryParams = {
      query,
      pageSize: config.maxProducts,
      fields: 'DEFAULT,products(title)',
    };
    this.searchResult$ = this.baseService.get(
      'help-center/search',
      queryParams
    );
    return this.searchResult$;
  }

    findContentItems(query: string, config: SearchBoxConfig): void {
        if (!query || query === '') {
            this.clearResults();
            return;
        }

        if (
            config.minCharactersBeforeRequest &&
            query.length < config.minCharactersBeforeRequest
        ) {
            return;
        }

        const queryParams = {
            query,
            pageSize : config.maxProducts,
            fields : 'DEFAULT,products(title,content,contentDocuments(FULL))'
        };
        this.baseService.get('help-center/search', queryParams).subscribe(res => {
            this.contentItemsSearchResult.next(res);
        });
    }

  clearResults(): void {
    this.searchResult.next(null);
  }
}
